module.exports = __webpack_public_path__ + "static/media/team-full.4b9ed62f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Team/assets/team-full.jpg
// module id = 1093
// module chunks = 0